<mibi-box-layout x-overflow-handling y-overflow-handling>
    <div class="mibi-card-container">
        <mat-card class="mibi-card">
            <div class="mibi-card-spacer mibi-card__flex">
                <div class="mibi-card-spacer__content"></div>
            </div>
            <mat-card-title class="mibi-card-title">
                {{ cardTitle }}
                <ng-content select="[mibi-card-title]"></ng-content>
            </mat-card-title>
            <mat-card-content 
                class="mibi-card-content mibi-card__flex"
                [ngClass]="{'mibi-card-content--no-auto-scroll': disableContentOverflowHandling !== undefined}"
            >
                <ng-content select="[mibi-card-content]"></ng-content>
            </mat-card-content>
            @if (cardActionsRef) {
                <mat-card-actions>
                    <ng-content select="[mibiCardActions]"></ng-content>
                </mat-card-actions>
            }
        </mat-card>
    </div>
</mibi-box-layout>
